import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, Transition as _Transition, Teleport as _Teleport, withModifiers as _withModifiers, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "bg-white rounded-lg border border-gray-200 shadow-sm" }
const _hoisted_2 = { class: "flex flex-wrap items-start justify-between gap-3 p-4 pb-2" }
const _hoisted_3 = { class: "flex-1 min-w-0" }
const _hoisted_4 = {
  key: 0,
  class: "text-lg font-bold text-gray-900"
}
const _hoisted_5 = {
  key: 1,
  class: "text-sm text-gray-500 mt-0.5 break-words"
}
const _hoisted_6 = { class: "flex items-center gap-2 w-full sm:w-auto flex-wrap justify-start sm:justify-end" }
const _hoisted_7 = { class: "relative" }
const _hoisted_8 = { class: "flex-1 min-w-0 truncate" }
const _hoisted_9 = { class: "flex-1 min-w-0 truncate text-left" }
const _hoisted_10 = { class: "px-2 pb-1 text-xs font-medium text-gray-500 uppercase tracking-wide" }
const _hoisted_11 = ["placeholder"]
const _hoisted_12 = { class: "overflow-y-auto max-h-48 min-h-0" }
const _hoisted_13 = ["checked", "onChange"]
const _hoisted_14 = { class: "truncate" }
const _hoisted_15 = {
  key: 0,
  class: "px-2 py-2 text-sm text-gray-500"
}
const _hoisted_16 = { class: "flex-1 min-w-0 truncate text-left" }
const _hoisted_17 = { class: "px-2 pb-1 text-xs font-medium text-gray-500 uppercase tracking-wide" }
const _hoisted_18 = { class: "overflow-y-auto max-h-48 min-h-0" }
const _hoisted_19 = ["checked", "onChange"]
const _hoisted_20 = { class: "truncate" }
const _hoisted_21 = {
  key: 0,
  class: "px-2 py-2 text-sm text-gray-500"
}
const _hoisted_22 = { class: "px-4 pb-2 relative overflow-visible" }
const _hoisted_23 = {
  key: 0,
  class: "h-64 flex items-center justify-center text-gray-500"
}
const _hoisted_24 = {
  key: 1,
  class: "h-64 relative overflow-visible"
}
const _hoisted_25 = {
  key: 0,
  class: "h-full flex flex-col items-center justify-center text-center px-6"
}
const _hoisted_26 = { class: "mt-3 text-sm font-medium text-gray-900" }
const _hoisted_27 = {
  key: 0,
  class: "mt-1 text-sm text-gray-500"
}
const _hoisted_28 = {
  key: 3,
  class: "h-full flex items-center justify-center text-gray-500 text-sm"
}
const _hoisted_29 = {
  key: 2,
  class: "mt-3 flex flex-col"
}
const _hoisted_30 = {
  key: 0,
  class: "flex flex-shrink-0 flex-wrap items-center gap-2 mb-2"
}
const _hoisted_31 = ["title"]
const _hoisted_32 = ["title"]
const _hoisted_33 = { class: "min-h-0 max-h-[7.5rem] overflow-x-auto overflow-y-auto" }
const _hoisted_34 = { class: "flex flex-wrap gap-2" }
const _hoisted_35 = ["onClick"]
const _hoisted_36 = ["onClick"]
const _hoisted_37 = { class: "p-4" }
const _hoisted_38 = { class: "flex flex-wrap items-center justify-between gap-2 mb-3" }
const _hoisted_39 = {
  key: 0,
  class: "flex items-center gap-2"
}
const _hoisted_40 = ["title"]
const _hoisted_41 = {
  key: 1,
  class: "flex items-center gap-2"
}
const _hoisted_42 = ["title"]
const _hoisted_43 = { class: "overflow-x-auto" }
const _hoisted_44 = { class: "w-full min-w-[500px] text-sm" }
const _hoisted_45 = { class: "text-left text-gray-500 uppercase tracking-wide text-xs" }
const _hoisted_46 = { class: "pb-2 pr-4 font-medium whitespace-nowrap" }
const _hoisted_47 = {
  key: 0,
  class: "sticky right-0 z-10 w-10 min-w-[2.5rem] pb-2 pl-2 text-center font-medium bg-white",
  scope: "col"
}
const _hoisted_48 = { key: 0 }
const _hoisted_49 = ["colspan"]
const _hoisted_50 = ["onMouseenter", "onClick"]
const _hoisted_51 = { class: "py-2 pr-4 whitespace-nowrap" }
const _hoisted_52 = ["onMouseenter"]
const _hoisted_53 = {
  key: 0,
  class: "sticky right-0 z-10 w-10 min-w-[2.5rem] py-2 pl-2 text-center bg-white"
}
const _hoisted_54 = ["title", "onClick"]
const _hoisted_55 = {
  key: 1,
  class: "sticky right-0 z-10 w-10 min-w-[2.5rem] py-2 pl-2 text-center bg-white"
}
const _hoisted_56 = ["title", "onClick"]
const _hoisted_57 = { key: 0 }
const _hoisted_58 = { class: "border-t-2 border-gray-300 font-semibold text-gray-900" }
const _hoisted_59 = { class: "py-2 whitespace-nowrap" }
const _hoisted_60 = {
  key: 0,
  class: "sticky right-0 z-10 w-10 min-w-[2.5rem] py-2 pl-2 bg-white"
}

import {
  Listbox,
  ListboxButton,
  ListboxOption,
  ListboxOptions,
  Popover,
  PopoverButton,
  PopoverPanel
} from '@headlessui/vue'
import { ChevronDownIcon } from '@heroicons/vue/20/solid'
import { ChartBarIcon, EyeIcon, EyeSlashIcon, FunnelIcon } from '@heroicons/vue/24/outline'
import {
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  Filler,
  Legend,
  LinearScale,
  LineElement,
  PointElement,
  Title,
  Tooltip
} from 'chart.js'
import { computed, ref, watch } from 'vue'
import { Bar, Line } from 'vue-chartjs'

import BasicSpinner from '@/components/BasicSpinner.vue'
import { activeElementsFor } from '@/components/reports/chartHover'
import ReportDateRangeFilter from '@/components/reports/ReportDateRangeFilter.vue'
import TablePagination from '@/components/TablePagination.vue'
import { useDropdownAnchor } from '@/composables/useDropdownAnchor'

const TABLE_PAGE_SIZE = 10
const GRIDLINE = '#e5e7eb'


export default {
  __name: 'ReportChart',
  props: {
  reportId: { type: String, default: '' },
  title: { type: String, default: '' },
  description: { type: String, default: '' },
  chartData: { type: Object, required: true },
  dateFilter: { type: Boolean, default: false },
  minDate: { type: String, default: undefined },
  maxDate: { type: String, default: undefined },
  selectedDateRange: { type: String, default: '' },
  selectedDateRangeLabel: { type: String, default: '' },
  customDateRange: { type: Object, default: null },
  dateRangeOptions: { type: Array, default: () => [] },
  dropdownFilter: { type: Boolean, default: false },
  dropdownOptions: { type: Array, default: () => [] },
  selectedDropdown: { type: String, default: '' },
  hasSupportingTable: { type: Boolean, default: false },
  tableData: { type: Object, default: null },
  labelColumnTitle: { type: String, default: '' },
  loading: { type: Boolean, default: false },
  chartType: { type: String, default: 'line' },
  tooltipData: { type: Object, default: null },
  dropdownFilter2: { type: Boolean, default: false },
  dropdownOptions2: { type: Array, default: () => [] },
  selectedDropdown2: { type: Array, default: () => [] },
  dropdown2Label: { type: String, default: null },
  dropdownFilter3: { type: Boolean, default: false },
  dropdown3Label: { type: String, default: 'All products' },
  dropdownOptions3: { type: Array, default: () => [] },
  selectedDropdown3: { type: [String, Array], default: [] },
  activeInChartProductIds: { type: Array, default: null },
  showLegend: { type: Boolean, default: false },
  tableHoverEnabled: { type: Boolean, default: true },
  viewReportLink: { type: String, default: '' },
  currencyFormat: { type: Boolean, default: false },
  emptyStateTitle: { type: String, default: 'No data to display' },
  emptyStateDescription: { type: String, default: '' },
  gridlines: { type: Boolean, default: false }
},
  emits: [
  'date-range-change',
  'dropdown-change',
  'dropdown-change-2',
  'dropdown-change-3',
  'active-chart-products-change'
],
  setup(__props, { emit: __emit }) {

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, BarElement, Filler, Title, Tooltip, Legend)

const props = __props

const emit = __emit

const {
  setReference: setDdRef,
  setFloating: setDdFloat,
  floatingStyles: ddStyles
} = useDropdownAnchor({
  placement: 'bottom-end'
})
const {
  setReference: setDd2Ref,
  setFloating: setDd2Float,
  floatingStyles: dd2Styles
} = useDropdownAnchor({
  placement: 'bottom-end'
})
const {
  setReference: setDd3Ref,
  setFloating: setDd3Float,
  floatingStyles: dd3Styles
} = useDropdownAnchor({
  placement: 'bottom-end'
})

const chartRef = ref(null)
const externalTooltipRef = ref(null)
const hiddenDatasets = ref(new Set())
const tablePage = ref(0)
const hoveredRowLabel = ref(null)
const hoveredColIndex = ref(null)
function startTableHover(label) {
  hoveredRowLabel.value = label
}

function clearTableHover() {
  hoveredRowLabel.value = null
  hoveredColIndex.value = null
}

function getChartInstance() {
  const r = chartRef.value
  return r?.chart?.value ?? r?.chart ?? r ?? null
}

function addAlpha(color, alpha) {
  if (!color) return color
  const match = color.match(/^rgb\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*\)$/)
  if (match) return `rgba(${match[1]}, ${match[2]}, ${match[3]}, ${alpha})`
  const matchA = color.match(/^rgba\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*,\s*[\d.]+\s*\)$/)
  if (matchA) return `rgba(${matchA[1]}, ${matchA[2]}, ${matchA[3]}, ${alpha})`
  return color
}

function externalTooltipHandler(context) {
  const { chart, tooltip } = context
  const el = externalTooltipRef.value
  if (!el) return
  if (tooltip.opacity === 0) {
    el.style.opacity = '0'
    return
  }
  // Build title
  let html = ''
  if (tooltip.title?.length) {
    html += `<div class="font-semibold text-gray-800 mb-1">${tooltip.title.join(' ')}</div>`
  }
  // Build body lines
  if (tooltip.body?.length) {
    tooltip.body.forEach((bodyItem, i) => {
      const colors = tooltip.labelColors?.[i] || {}
      const color = colors.borderColor || colors.backgroundColor || '#6b7280'
      const lines = bodyItem.lines || []
      lines.forEach(line => {
        if (line) {
          html += `<div class="flex items-center gap-1.5 text-gray-500"><span class="inline-block w-2 h-2 rounded-sm flex-shrink-0" style="background:${color}"></span>${line}</div>`
        }
      })
    })
  }
  // Build afterBody lines
  if (tooltip.afterBody?.length) {
    tooltip.afterBody.forEach(line => {
      if (line) {
        html += `<div class="text-gray-500">${line}</div>`
      }
    })
  }
  el.innerHTML = html
  // Force layout so offsetWidth/offsetHeight reflect the new content
  el.style.display = 'block'
  const containerRect = chart.canvas.parentElement.getBoundingClientRect()
  const x = containerRect.left + tooltip.caretX
  const elWidth = el.offsetWidth
  const elHeight = el.offsetHeight

  // Horizontal: center on hovered x, clamp to viewport
  let left = x - elWidth / 2
  const maxLeft = window.innerWidth - elWidth - 4
  if (left < 4) left = 4
  if (left > maxLeft) left = maxLeft
  el.style.left = left + 'px'

  // Vertical: prefer above chart, flip below if not enough room, clamp to viewport
  const aboveTop = containerRect.top + chart.chartArea.top - elHeight - 8
  const belowTop = containerRect.top + chart.chartArea.bottom + 8
  let top
  if (aboveTop >= 4) {
    top = aboveTop
  } else if (belowTop + elHeight <= window.innerHeight - 4) {
    top = belowTop
  } else {
    // Neither fits cleanly — pin to top of viewport (content scrolls via overflow-y)
    top = 4
  }
  el.style.top = top + 'px'
  el.style.opacity = '1'
}

const crosshairPlugin = {
  id: 'crosshairLine',
  afterDraw(chart) {
    const tooltip = chart.tooltip
    if (!tooltip || !tooltip.getActiveElements().length) return
    const x = tooltip.getActiveElements()[0].element.x
    const { top, bottom } = chart.chartArea
    const ctx = chart.ctx
    ctx.save()
    ctx.beginPath()
    ctx.moveTo(x, top)
    ctx.lineTo(x, bottom)
    ctx.lineWidth = 1
    ctx.strokeStyle = 'rgba(107, 114, 128, 0.3)'
    ctx.setLineDash([4, 4])
    ctx.stroke()
    ctx.restore()
  }
}

const dropdownDisplayLabel = computed(() => {
  const opt = props.dropdownOptions?.find(o => o.value === props.selectedDropdown)
  return opt?.label ?? props.selectedDropdown ?? 'Select'
})

const dropdown2PanelTitle = computed(() => {
  if (props.dropdown2Label) return props.dropdown2Label
  const first = props.dropdownOptions2?.[0]
  if (first?.label?.toLowerCase().includes('fulfillment') || first?.label?.toLowerCase().includes('fulfilment'))
    return 'Fulfillment methods'
  return 'Stores'
})

const dropdownDisplayLabel2 = computed(() => {
  const sel = props.selectedDropdown2
  const allLabel = dropdown2PanelTitle.value === 'Stores' ? 'All stores' : 'All fulfillment methods'
  if (!Array.isArray(sel) || sel.length === 0) return allLabel
  const allValues = (props.dropdownOptions2 ?? []).map(o => o.value)
  if (sel.length >= allValues.length) return allLabel
  if (sel.length === 1) {
    const opt = props.dropdownOptions2?.find(o => o.value === sel[0])
    return opt?.label ?? '1 selected'
  }
  return `${sel.length} selected`
})

const selectedDropdown2Set = computed(() => {
  const sel = props.selectedDropdown2
  return new Set(Array.isArray(sel) ? sel : [])
})

const dropdown2SearchQuery = ref('')

const filteredDropdown2Options = computed(() => {
  const opts = props.dropdownOptions2 ?? []
  const q = (dropdown2SearchQuery.value || '').trim().toLowerCase()
  const filtered = q ? opts.filter(opt => (opt.label || '').toLowerCase().includes(q)) : opts
  return [...filtered].sort((a, b) => (a.label ?? '').localeCompare(b.label ?? '', undefined, { sensitivity: 'base' }))
})

function toggleDropdown2Option(value) {
  const sel = Array.isArray(props.selectedDropdown2) ? [...props.selectedDropdown2] : []
  const set = new Set(sel)
  if (set.has(value)) set.delete(value)
  else set.add(value)
  emit('dropdown-change-2', [...set])
}

const dropdownDisplayLabel3 = computed(() => {
  const sel = props.selectedDropdown3
  if (!Array.isArray(sel) || sel.length === 0) return props.dropdown3Label
  const allValues = (props.dropdownOptions3 ?? []).map(o => o.value)
  if (sel.length >= allValues.length) return props.dropdown3Label
  if (sel.length === 1) {
    const opt = props.dropdownOptions3?.find(o => o.value === sel[0])
    return opt?.label ?? '1 selected'
  }
  return `${sel.length} selected`
})

const selectedDropdown3Set = computed(() => {
  const sel = props.selectedDropdown3
  return new Set(Array.isArray(sel) ? sel : [])
})

const productSearchQuery = ref('')

const filteredProductOptions = computed(() => {
  const opts = props.dropdownOptions3 ?? []
  const q = (productSearchQuery.value || '').trim().toLowerCase()
  const filtered = q ? opts.filter(opt => (opt.label || '').toLowerCase().includes(q)) : opts
  return [...filtered].sort((a, b) => (a.label ?? '').localeCompare(b.label ?? '', undefined, { sensitivity: 'base' }))
})

const activeInChartSet = computed(() =>
  props.activeInChartProductIds != null ? new Set(props.activeInChartProductIds) : null
)

const allChartProductsVisible = computed(() => {
  if (!activeInChartSet.value || !props.dropdownOptions3?.length) return false
  return activeInChartSet.value.size >= props.dropdownOptions3.length
})

const allDropdown3Selected = computed(() => {
  if (!props.dropdownOptions3?.length) return false
  return selectedDropdown3Set.value.size >= props.dropdownOptions3.length
})

const allTableRowsVisible = computed(() => {
  if (!activeInChartSet.value) return false
  const rowIds = (tableRowsForTable.value ?? [])
    .map(r => r?.productId ?? r?.fulfillmentMethodId)
    .filter(id => id != null)
  if (!rowIds.length) return false
  return rowIds.every(id => activeInChartSet.value.has(id))
})

// True while at least one table row is still shown in the chart. Used to
// decide which master-eye icon to display: slashed only when EVERY row is
// hidden, regular eye otherwise.
const anyTableRowVisible = computed(() => {
  if (!activeInChartSet.value) return false
  const rowIds = (tableRowsForTable.value ?? [])
    .map(r => r?.productId ?? r?.fulfillmentMethodId)
    .filter(id => id != null)
  if (!rowIds.length) return false
  return rowIds.some(id => activeInChartSet.value.has(id))
})

function rowId(row) {
  return row?.productId ?? row?.fulfillmentMethodId
}

function datasetId(d) {
  return d?.productId ?? d?.fulfillmentMethodId
}

function datasetIndexForRow(row) {
  const datasets = props.chartData?.datasets ?? []
  return datasets.findIndex(ds => ds.label === row.label)
}

function isRowHidden(row) {
  if (props.activeInChartProductIds != null) {
    const id = rowId(row)
    return id != null && !activeInChartSet.value?.has(id)
  }
  if (canToggleDatasets.value) {
    const idx = datasetIndexForRow(row)
    return idx >= 0 && hiddenDatasets.value.has(idx)
  }
  return false
}

const hasMultipleDatasets = computed(() => (props.chartData?.datasets?.length ?? 0) > 1)

// Any report with at least one dataset can have its datasets toggled via
// hiddenDatasets, as long as we're not in Mode A (product-based toggle).
const canToggleDatasets = computed(
  () => props.activeInChartProductIds == null && (props.chartData?.datasets?.length ?? 0) >= 1
)

const allDatasetsVisible = computed(() => {
  const len = props.chartData?.datasets?.length ?? 0
  if (len === 0) return false
  return hiddenDatasets.value.size === 0
})

// True while at least one dataset is still shown in the chart. Used to
// decide which master-eye icon to display: slashed only when EVERY dataset
// is hidden, regular eye otherwise.
const anyDatasetVisible = computed(() => {
  const len = props.chartData?.datasets?.length ?? 0
  if (len === 0) return false
  return hiddenDatasets.value.size < len
})

const hasSourceData = computed(() => (props.chartData?.datasets ?? []).some(ds => (ds.data ?? []).some(v => v > 0)))

const displayChartData = computed(() => {
  const data = props.chartData
  if (!data || activeInChartSet.value == null) return data
  const ids = activeInChartSet.value
  const filtered = (data.datasets ?? []).filter(d => {
    const id = datasetId(d)
    return id != null && ids.has(id)
  })
  return { ...data, datasets: filtered }
})

const displayTableData = computed(() => {
  const data = props.tableData
  if (!data || activeInChartSet.value == null) return data
  const ids = activeInChartSet.value
  const rows = (data.rows ?? []).filter(r => {
    const id = rowId(r)
    return id != null && ids.has(id)
  })
  return { ...data, rows }
})

const visibleItemIds = computed(() => {
  const datasets = displayChartData.value?.datasets ?? []
  const ids = new Set()
  datasets.forEach(ds => {
    const id = datasetId(ds)
    if (id != null) ids.add(id)
  })
  return ids
})

const tableRowsForTable = computed(() => {
  if (props.activeInChartProductIds != null && props.tableData?.rows?.length) {
    return props.tableData.rows
  }
  return displayTableData.value?.rows ?? []
})

const tableColumnCount = computed(() => {
  const columns = displayTableData.value?.columns ?? props.tableData?.columns ?? []
  const eyeColumn = props.activeInChartProductIds != null || canToggleDatasets.value ? 1 : 0
  return columns.length + 2 + eyeColumn
})

const tablePageSize = TABLE_PAGE_SIZE
const paginatedTableRows = computed(() => {
  const rows = tableRowsForTable.value
  const start = tablePage.value * TABLE_PAGE_SIZE
  return rows.slice(start, start + TABLE_PAGE_SIZE)
})

const tableTotalRow = computed(() => {
  const rows = tableRowsForTable.value.filter(row => !isRowHidden(row))
  const columns = displayTableData.value?.columns ?? props.tableData?.columns ?? []
  if (!rows.length || !columns.length) return null
  const parseCell = s => parseFloat(String(s ?? '').replace(/[$,]/g, ''))
  const totalIsCurrency = rows.some(r => typeof r.total === 'string' && r.total.includes('$'))
  const formatCurrency = n =>
    `$${(Math.round(n * 100) / 100).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
  const formatNumber = n => Math.round(n).toLocaleString()
  const formatForColumn = (n, col) => {
    if (col.format === 'number') return formatNumber(n)
    if (col.format === 'currency') return formatCurrency(n)
    return totalIsCurrency ? formatCurrency(n) : String(Math.round(n * 100) / 100)
  }
  const values = {}
  columns.forEach(col => {
    if (col.format === 'string') {
      values[col.key] = '—'
      return
    }
    const sum = rows.reduce((acc, row) => {
      const val = parseCell(row.values?.[col.key])
      return acc + (isNaN(val) ? 0 : val)
    }, 0)
    values[col.key] = formatForColumn(sum, col)
  })
  const totalSum = rows.reduce((acc, row) => {
    const val = parseCell(row.total)
    return acc + (isNaN(val) ? 0 : val)
  }, 0)
  return {
    values,
    total: totalIsCurrency ? formatCurrency(totalSum) : formatNumber(totalSum)
  }
})

function onTableRowClick(row) {
  // Stacked bar reports: use activeInChartProductIds
  if (props.activeInChartProductIds != null) {
    const id = rowId(row)
    if (id == null) return
    const allIds = tableRowsForTable.value.map(r => rowId(r)).filter(v => v != null)
    if (activeInChartSet.value?.size === 1 && activeInChartSet.value.has(id)) {
      emit('active-chart-products-change', allIds)
    } else {
      emit('active-chart-products-change', [id])
    }
    return
  }

  // Line chart reports: use hiddenDatasets
  if (!hasMultipleDatasets.value) return
  const dsIndex = datasetIndexForRow(row)
  if (dsIndex < 0) return

  const chart = getChartInstance()
  if (!chart) return

  const datasets = props.chartData?.datasets ?? []
  const currentlyHidden = hiddenDatasets.value
  const visibleIndices = Array.from({ length: datasets.length }, (_, i) => i).filter(i => !currentlyHidden.has(i))

  if (visibleIndices.length === 1 && visibleIndices[0] === dsIndex) {
    // This is the only visible one — show all
    hiddenDatasets.value = new Set()
    datasets.forEach((_, i) => chart.setDatasetVisibility(i, true))
  } else {
    // Solo this dataset — hide all others
    const next = new Set()
    datasets.forEach((_, i) => {
      if (i !== dsIndex) {
        next.add(i)
        chart.setDatasetVisibility(i, false)
      } else {
        chart.setDatasetVisibility(i, true)
      }
    })
    hiddenDatasets.value = next
  }
  chart.update()
}

function onTablePageChange(page) {
  tablePage.value = page
}

function toggleProductOption(value) {
  const sel = Array.isArray(props.selectedDropdown3) ? [...props.selectedDropdown3] : []
  const set = new Set(sel)
  if (set.has(value)) set.delete(value)
  else set.add(value)

  emit('dropdown-change-3', [...set])
}

function toggleActiveChartProduct(id) {
  if (props.activeInChartProductIds == null) return
  const current = new Set(props.activeInChartProductIds)
  if (current.has(id)) current.delete(id)
  else current.add(id)
  emit('active-chart-products-change', [...current])
}

const productIdToColor = computed(() => {
  const rows = props.tableData?.rows ?? []
  const map = {}
  rows.forEach(r => {
    const id = rowId(r)
    if (id != null && r.color != null) map[id] = r.color
  })
  return map
})

function toggleDataset(index) {
  const ref = chartRef.value
  const chart = ref?.chart?.value ?? ref?.chart ?? ref
  if (!chart) return
  const next = new Set(hiddenDatasets.value)
  if (next.has(index)) {
    next.delete(index)
    chart.setDatasetVisibility(index, true)
  } else {
    next.add(index)
    chart.setDatasetVisibility(index, false)
  }
  hiddenDatasets.value = next
  chart.update()
}

function toggleAllDatasets() {
  const chart = getChartInstance()
  if (!chart) return
  const datasets = props.chartData?.datasets ?? []
  if (hiddenDatasets.value.size === 0) {
    // All visible → hide all
    const next = new Set()
    datasets.forEach((_, i) => {
      next.add(i)
      chart.setDatasetVisibility(i, false)
    })
    hiddenDatasets.value = next
  } else {
    // Some hidden → show all
    hiddenDatasets.value = new Set()
    datasets.forEach((_, i) => chart.setDatasetVisibility(i, true))
  }
  chart.update()
}

watch(
  () => props.chartData?.datasets,
  () => {
    hiddenDatasets.value = new Set()
  },
  { deep: true }
)

watch(
  () => props.tableData?.rows?.length,
  () => {
    tablePage.value = 0
  }
)

watch(hoveredRowLabel, label => {
  const chart = getChartInstance()
  if (!chart) return
  const isStacked = props.chartType === 'stackedBar'
  chart.data.datasets.forEach(ds => {
    if (label == null) {
      if (ds._origBorderColor != null) {
        ds.borderColor = ds._origBorderColor
        ds.backgroundColor = ds._origBgColor
        ds.borderWidth = ds._origBorderWidth
        delete ds._origBorderColor
        delete ds._origBgColor
        delete ds._origBorderWidth
      }
    } else {
      if (ds._origBorderColor == null) {
        ds._origBorderColor = ds.borderColor
        ds._origBgColor = ds.backgroundColor
        ds._origBorderWidth = ds.borderWidth
      }
      if (ds.label === label) {
        ds.borderColor = ds._origBorderColor
        ds.backgroundColor = ds._origBgColor
        ds.borderWidth = isStacked ? ds._origBorderWidth : 2.5
      } else {
        ds.borderColor = addAlpha(ds._origBorderColor, 0.15)
        ds.backgroundColor = addAlpha(ds._origBgColor, isStacked ? 0.15 : 0.02)
        ds.borderWidth = isStacked ? ds._origBorderWidth : 1
      }
    }
  })
  chart.update('none')
})

watch([hoveredRowLabel, hoveredColIndex], ([label, colIdx]) => {
  const chart = getChartInstance()
  if (!chart) return
  const active = activeElementsFor(chart.data.datasets, label, colIdx)
  chart.setActiveElements(active)
  chart.tooltip.setActiveElements(active, { x: 0, y: 0 })
  chart.update('none')
})

const CURRENCY_AXIS_REPORT_IDS = ['payouts-report', 'products-sold-breakdown', 'upsell-sales', 'referral-code-usage']
const chartOptions = computed(() => {
  const isStackedBar = props.chartType === 'stackedBar'
  const isCurrencyAxis = props.currencyFormat || CURRENCY_AXIS_REPORT_IDS.includes(props.reportId)
  const isSinglePoint = displayChartData.value?.labels?.length === 1
  const periodBreakdown = props.tooltipData?.periodBreakdown || []
  return {
    responsive: true,
    maintainAspectRatio: false,
    elements: {
      point: {
        radius: isSinglePoint ? 5 : 0,
        hoverRadius: 5,
        hitRadius: 30
      }
    },
    interaction: { mode: 'index', intersect: false },
    plugins: {
      legend: { display: false },
      tooltip: {
        enabled: false,
        external: externalTooltipHandler,
        mode: 'index',
        intersect: false,
        callbacks:
          isStackedBar && periodBreakdown.length
            ? {
                title(context) {
                  const i = context[0]?.dataIndex
                  const period = periodBreakdown[i]
                  return period?.period_label ?? context[0]?.label ?? ''
                },
                afterBody(context) {
                  const i = context[0]?.dataIndex
                  const period = periodBreakdown[i]
                  if (!period) return []
                  const visible = visibleItemIds.value
                  if (period.fulfillment_methods?.length) {
                    const filtered = period.fulfillment_methods.filter(fm => visible.has(fm.fulfillment_method_id))
                    if (!filtered.length) return []
                    const lines = filtered.map(fm => `${fm.name}: ${fm.order_count} orders`)
                    const total = filtered.reduce((s, fm) => s + (fm.order_count || 0), 0)
                    lines.push(`Total: ${total} orders`)
                    return lines
                  }
                  if (period.products?.length) {
                    const filtered = period.products.filter(p => visible.has(p.product_id))
                    if (!filtered.length) return []
                    const lines = filtered.map(
                      p =>
                        `${p.product_name}: ${p.quantity} units, $${Number(p.revenue_cents / 100).toLocaleString(undefined, { minimumFractionDigits: 2 })}`
                    )
                    const total = filtered.reduce((s, p) => s + (p.revenue_cents || 0), 0)
                    lines.push(`Total: $${Number(total / 100).toLocaleString(undefined, { minimumFractionDigits: 2 })}`)
                    return lines
                  }
                  return []
                },
                label() {
                  return ''
                }
              }
            : {
                label(context) {
                  const value = context.parsed.y
                  const label = context.dataset.label || ''
                  if (context.dataset.yAxisID === 'y' && label.toLowerCase().includes('revenue')) {
                    return `${label}: $${Number(value).toLocaleString()}`
                  }
                  return `${label}: ${value}`
                }
              }
      }
    },
    scales: {
      x: {
        grid: { display: false },
        stacked: isStackedBar
      },
      y: {
        type: 'linear',
        display: true,
        position: 'left',
        grid: props.gridlines ? { display: true, color: GRIDLINE } : { display: false },
        stacked: isStackedBar,
        ticks: {
          precision: isCurrencyAxis ? undefined : 0,
          callback(value) {
            if (isCurrencyAxis) {
              return typeof value === 'number' && value >= 1000 ? `$${value / 1000}k` : `$${value}`
            }
            if (typeof value === 'number') {
              return Number.isInteger(value) ? String(value) : ''
            }
            return value
          }
        }
      },
      y1: {
        type: 'linear',
        display: (props.chartData?.datasets ?? []).some(d => d.yAxisID === 'y1'),
        position: 'right',
        grid: { drawOnChartArea: false },
        ticks: {
          callback(value) {
            if (typeof value === 'number') {
              return value >= 1000 ? `$${value / 1000}k` : `$${value}`
            }
            return value
          }
        }
      }
    }
  }
})

return (_ctx, _cache) => {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (__props.title)
          ? (_openBlock(), _createElementBlock("h3", _hoisted_4, _toDisplayString(__props.title), 1))
          : _createCommentVNode("", true),
        (__props.description)
          ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(__props.description), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_6, [
        (__props.viewReportLink)
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 0,
              to: __props.viewReportLink,
              class: "text-sm font-medium text-brand-600 hover:text-brand-700"
            }, {
              default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                _createTextVNode(" View Full Report → ", -1)
              ]))]),
              _: 1
            }, 8, ["to"]))
          : _createCommentVNode("", true),
        (__props.dateFilter)
          ? (_openBlock(), _createBlock(ReportDateRangeFilter, {
              key: 1,
              options: __props.dateRangeOptions,
              selected: __props.selectedDateRange,
              "selected-label": __props.selectedDateRangeLabel,
              "custom-range": __props.customDateRange,
              onChange: _cache[0] || (_cache[0] = $event => (_ctx.$emit('date-range-change', $event)))
            }, null, 8, ["options", "selected", "selected-label", "custom-range"]))
          : _createCommentVNode("", true),
        (__props.dropdownFilter)
          ? (_openBlock(), _createBlock(_unref(Listbox), {
              key: 2,
              "model-value": __props.selectedDropdown,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (_ctx.$emit('dropdown-change', $event)))
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_unref(ListboxButton), {
                    ref: _unref(setDdRef),
                    class: "report-filter-pill inline-flex items-center gap-1.5 rounded-full border border-gray-300 bg-white px-3 py-1.5 text-sm text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-1 focus:ring-brand-500 focus:border-brand-500 min-w-0"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(FunnelIcon), { class: "h-4 w-4 text-gray-500 shrink-0" }),
                      _createElementVNode("span", _hoisted_8, _toDisplayString(dropdownDisplayLabel.value), 1),
                      _createVNode(_unref(ChevronDownIcon), {
                        class: "h-4 w-4 text-gray-500 shrink-0 ml-0.5",
                        "aria-hidden": "true"
                      })
                    ]),
                    _: 1
                  }, 512),
                  (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
                    _createVNode(_Transition, {
                      "enter-active-class": "transition ease-out duration-100",
                      "enter-from-class": "transform opacity-0 scale-95",
                      "enter-to-class": "transform opacity-100 scale-100",
                      "leave-active-class": "transition ease-in duration-75",
                      "leave-from-class": "transform opacity-100 scale-100",
                      "leave-to-class": "transform opacity-0 scale-95"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(ListboxOptions), {
                          ref: _unref(setDdFloat),
                          style: _normalizeStyle(_unref(ddStyles)),
                          class: "z-50 min-w-[10rem] overflow-y-auto rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 py-1"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.dropdownOptions, (opt) => {
                              return (_openBlock(), _createBlock(_unref(ListboxOption), {
                                key: opt.value,
                                value: opt.value,
                                class: "cursor-pointer"
                              }, {
                                default: _withCtx(({ active }) => [
                                  _createElementVNode("li", {
                                    class: _normalizeClass([active ? 'bg-gray-100' : '', 'text-left text-sm text-gray-700 rounded px-2 py-1.5 mx-1'])
                                  }, _toDisplayString(opt.label), 3)
                                ]),
                                _: 2
                              }, 1032, ["value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["style"])
                      ]),
                      _: 1
                    })
                  ]))
                ])
              ]),
              _: 1
            }, 8, ["model-value"]))
          : _createCommentVNode("", true),
        (__props.dropdownFilter2)
          ? (_openBlock(), _createBlock(_unref(Popover), {
              key: 3,
              as: "div",
              class: "relative inline-block text-left max-w-[14rem]"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(PopoverButton), {
                  ref: _unref(setDd2Ref),
                  class: "report-filter-pill inline-flex items-center gap-1.5 rounded-full border border-gray-300 bg-white px-3 py-1.5 text-sm text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-1 focus:ring-brand-500 focus:border-brand-500 min-w-0 w-full max-w-full"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(FunnelIcon), { class: "h-4 w-4 text-gray-500 shrink-0" }),
                    _createElementVNode("span", _hoisted_9, _toDisplayString(dropdownDisplayLabel2.value), 1),
                    _createVNode(_unref(ChevronDownIcon), {
                      class: "h-4 w-4 text-gray-500 shrink-0 ml-0.5",
                      "aria-hidden": "true"
                    })
                  ]),
                  _: 1
                }, 512),
                (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
                  _createVNode(_Transition, {
                    "enter-active-class": "transition ease-out duration-100",
                    "enter-from-class": "transform opacity-0 scale-95",
                    "enter-to-class": "transform opacity-100 scale-100",
                    "leave-active-class": "transition ease-in duration-75",
                    "leave-from-class": "transform opacity-100 scale-100",
                    "leave-to-class": "transform opacity-0 scale-95"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(PopoverPanel), {
                        ref: _unref(setDd2Float),
                        style: _normalizeStyle(_unref(dd2Styles)),
                        class: "z-50 min-w-[12rem] max-w-[20rem] max-h-60 overflow-hidden flex flex-col py-2 rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_10, _toDisplayString(dropdown2PanelTitle.value), 1),
                          _createElementVNode("button", {
                            type: "button",
                            class: "mx-2 mb-2 text-left text-sm text-brand-600 hover:text-brand-700 focus:outline-none",
                            onClick: _cache[2] || (_cache[2] = _withModifiers($event => (
                    selectedDropdown2Set.value.size > 0
                      ? emit('dropdown-change-2', [])
                      : emit(
                          'dropdown-change-2',
                          __props.dropdownOptions2.map(o => o.value)
                        )
                  ), ["stop"]))
                          }, _toDisplayString(selectedDropdown2Set.value.size > 0 ? 'Clear all' : 'Select all'), 1),
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => ((dropdown2SearchQuery).value = $event)),
                            type: "search",
                            placeholder: `Search ${dropdown2PanelTitle.value.toLowerCase()}...`,
                            class: "mx-2 mb-2 px-2 py-1.5 text-sm border border-gray-300 rounded-md focus:ring-1 focus:ring-brand-500 focus:border-brand-500",
                            autocomplete: "off",
                            onClick: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["stop"]))
                          }, null, 8, _hoisted_11), [
                            [_vModelText, dropdown2SearchQuery.value]
                          ]),
                          _createElementVNode("div", _hoisted_12, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredDropdown2Options.value, (opt) => {
                              return (_openBlock(), _createElementBlock("label", {
                                key: opt.value,
                                class: "flex items-center gap-2 px-2 py-1.5 text-sm text-gray-700 hover:bg-gray-100 cursor-pointer"
                              }, [
                                _createElementVNode("input", {
                                  type: "checkbox",
                                  checked: selectedDropdown2Set.value.has(opt.value),
                                  class: "rounded border-gray-300",
                                  onChange: $event => (toggleDropdown2Option(opt.value))
                                }, null, 40, _hoisted_13),
                                _createElementVNode("span", _hoisted_14, _toDisplayString(opt.label), 1)
                              ]))
                            }), 128)),
                            (filteredDropdown2Options.value.length === 0)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_15, " No results match your search. "))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _: 1
                      }, 8, ["style"])
                    ]),
                    _: 1
                  })
                ]))
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (__props.dropdownFilter3)
          ? (_openBlock(), _createBlock(_unref(Popover), {
              key: 4,
              as: "div",
              class: "relative inline-block text-left max-w-[14rem]"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(PopoverButton), {
                  ref: _unref(setDd3Ref),
                  class: "report-filter-pill inline-flex items-center gap-1.5 rounded-full border border-gray-300 bg-white px-3 py-1.5 text-sm text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-1 focus:ring-brand-500 focus:border-brand-500 min-w-0 w-full max-w-full"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(FunnelIcon), { class: "h-4 w-4 text-gray-500 shrink-0" }),
                    _createElementVNode("span", _hoisted_16, _toDisplayString(dropdownDisplayLabel3.value), 1),
                    _createVNode(_unref(ChevronDownIcon), {
                      class: "h-4 w-4 text-gray-500 shrink-0 ml-0.5",
                      "aria-hidden": "true"
                    })
                  ]),
                  _: 1
                }, 512),
                (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
                  _createVNode(_Transition, {
                    "enter-active-class": "transition ease-out duration-100",
                    "enter-from-class": "transform opacity-0 scale-95",
                    "enter-to-class": "transform opacity-100 scale-100",
                    "leave-active-class": "transition ease-in duration-75",
                    "leave-from-class": "transform opacity-100 scale-100",
                    "leave-to-class": "transform opacity-0 scale-95"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(PopoverPanel), {
                        ref: _unref(setDd3Float),
                        style: _normalizeStyle(_unref(dd3Styles)),
                        class: "z-50 min-w-[12rem] max-w-[20rem] max-h-60 overflow-hidden flex flex-col py-2 rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_17, _toDisplayString(__props.dropdown3Label.replace(/^All\s*/i, '')), 1),
                          _createElementVNode("button", {
                            type: "button",
                            class: "mx-2 mb-2 text-left text-sm text-brand-600 hover:text-brand-700 focus:outline-none",
                            onClick: _cache[5] || (_cache[5] = _withModifiers($event => (
                    selectedDropdown3Set.value.size > 0
                      ? emit('dropdown-change-3', [])
                      : emit(
                          'dropdown-change-3',
                          __props.dropdownOptions3.map(o => o.value)
                        )
                  ), ["stop"]))
                          }, _toDisplayString(selectedDropdown3Set.value.size > 0 ? 'Clear all' : 'Select all'), 1),
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => ((productSearchQuery).value = $event)),
                            type: "search",
                            placeholder: "Search products...",
                            class: "mx-2 mb-2 px-2 py-1.5 text-sm border border-gray-300 rounded-md focus:ring-1 focus:ring-brand-500 focus:border-brand-500",
                            autocomplete: "off",
                            onClick: _cache[7] || (_cache[7] = _withModifiers(() => {}, ["stop"]))
                          }, null, 512), [
                            [_vModelText, productSearchQuery.value]
                          ]),
                          _createElementVNode("div", _hoisted_18, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredProductOptions.value, (opt) => {
                              return (_openBlock(), _createElementBlock("label", {
                                key: opt.value,
                                class: "flex items-center gap-2 px-2 py-1.5 text-sm text-gray-700 hover:bg-gray-100 cursor-pointer"
                              }, [
                                _createElementVNode("input", {
                                  type: "checkbox",
                                  checked: selectedDropdown3Set.value.has(opt.value),
                                  class: "rounded border-gray-300",
                                  onChange: $event => (toggleProductOption(opt.value))
                                }, null, 40, _hoisted_19),
                                _createElementVNode("span", _hoisted_20, _toDisplayString(opt.label), 1)
                              ]))
                            }), 128)),
                            (filteredProductOptions.value.length === 0)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_21, " No products match your search. "))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _: 1
                      }, 8, ["style"])
                    ]),
                    _: 1
                  })
                ]))
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_22, [
      (__props.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
            _createVNode(BasicSpinner)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_24, [
            _createElementVNode("div", {
              ref_key: "externalTooltipRef",
              ref: externalTooltipRef,
              class: "pointer-events-none fixed z-50 rounded-lg border border-gray-200 bg-white px-3 py-2.5 text-sm shadow-sm transition-opacity duration-150 overflow-y-auto",
              style: {"opacity":"0","top":"0","left":"0","max-height":"calc(100vh - 16px)"}
            }, null, 512),
            (!hasSourceData.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                  _createVNode(_unref(ChartBarIcon), { class: "h-8 w-8 text-gray-300" }),
                  _createElementVNode("p", _hoisted_26, _toDisplayString(__props.emptyStateTitle), 1),
                  (__props.emptyStateDescription)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_27, _toDisplayString(__props.emptyStateDescription), 1))
                    : _createCommentVNode("", true)
                ]))
              : (__props.chartType === 'line' && displayChartData.value?.datasets?.length)
                ? (_openBlock(), _createBlock(_unref(Line), {
                    key: 1,
                    ref_key: "chartRef",
                    ref: chartRef,
                    data: displayChartData.value,
                    options: chartOptions.value,
                    plugins: [crosshairPlugin]
                  }, null, 8, ["data", "options", "plugins"]))
                : (__props.chartType === 'stackedBar' && displayChartData.value?.datasets?.length)
                  ? (_openBlock(), _createBlock(_unref(Bar), {
                      key: 2,
                      ref_key: "chartRef",
                      ref: chartRef,
                      data: displayChartData.value,
                      options: chartOptions.value,
                      plugins: [crosshairPlugin]
                    }, null, 8, ["data", "options", "plugins"]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_28, "No data to display"))
          ])),
      (
          __props.showLegend &&
          hasSourceData.value &&
          (__props.activeInChartProductIds != null ? __props.dropdownOptions3?.length : __props.chartData?.datasets?.length) &&
          !__props.loading
        )
        ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
            ((__props.dropdownFilter3 || __props.activeInChartProductIds != null) && __props.dropdownOptions3?.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                  (__props.activeInChartProductIds != null)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        type: "button",
                        class: "inline-flex items-center justify-center rounded p-1 text-gray-500 hover:bg-gray-100 hover:text-gray-700 focus:outline-none focus:ring-1 focus:ring-brand-500",
                        title: allChartProductsVisible.value ? 'Hide all in chart' : 'Show all in chart',
                        onClick: _cache[8] || (_cache[8] = _withModifiers($event => (
                allChartProductsVisible.value
                  ? emit('active-chart-products-change', [])
                  : emit(
                      'active-chart-products-change',
                      __props.dropdownOptions3.map(o => o.value)
                    )
              ), ["stop"]))
                      }, [
                        (allChartProductsVisible.value)
                          ? (_openBlock(), _createBlock(_unref(EyeSlashIcon), {
                              key: 0,
                              class: "h-4 w-4"
                            }))
                          : (_openBlock(), _createBlock(_unref(EyeIcon), {
                              key: 1,
                              class: "h-4 w-4"
                            }))
                      ], 8, _hoisted_31))
                    : (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        type: "button",
                        class: "inline-flex items-center justify-center rounded p-1 text-gray-500 hover:bg-gray-100 hover:text-gray-700 focus:outline-none focus:ring-1 focus:ring-brand-500",
                        title: allDropdown3Selected.value ? 'Hide all' : 'Show all',
                        onClick: _cache[9] || (_cache[9] = _withModifiers($event => (
                allDropdown3Selected.value
                  ? emit('dropdown-change-3', [])
                  : emit(
                      'dropdown-change-3',
                      __props.dropdownOptions3.map(o => o.value)
                    )
              ), ["stop"]))
                      }, [
                        (allDropdown3Selected.value)
                          ? (_openBlock(), _createBlock(_unref(EyeSlashIcon), {
                              key: 0,
                              class: "h-4 w-4"
                            }))
                          : (_openBlock(), _createBlock(_unref(EyeIcon), {
                              key: 1,
                              class: "h-4 w-4"
                            }))
                      ], 8, _hoisted_32))
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_33, [
              _createElementVNode("div", _hoisted_34, [
                (__props.activeInChartProductIds != null && __props.dropdownOptions3?.length)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(__props.dropdownOptions3, (opt) => {
                      return (_openBlock(), _createElementBlock("button", {
                        key: opt.value,
                        type: "button",
                        class: _normalizeClass(["inline-flex items-center gap-1.5 rounded-full border px-3 py-1 text-sm transition-colors", 
                  !activeInChartSet.value?.has(opt.value)
                    ? 'border-gray-200 bg-gray-50 text-gray-400'
                    : 'border-gray-300 bg-white text-gray-700 hover:bg-gray-50'
                ]),
                        onClick: $event => (toggleActiveChartProduct(opt.value))
                      }, [
                        _createElementVNode("span", {
                          class: _normalizeClass([
                    'inline-block w-4 rounded',
                    __props.chartType === 'stackedBar' ? 'h-3' : 'h-0.5',
                    !activeInChartSet.value?.has(opt.value) ? 'bg-gray-300' : ''
                  ]),
                          style: _normalizeStyle(
                    activeInChartSet.value?.has(opt.value)
                      ? { backgroundColor: productIdToColor.value[opt.value] || '#6b7280' }
                      : {}
                  )
                        }, null, 6),
                        _createTextVNode(" " + _toDisplayString(opt.label), 1)
                      ], 10, _hoisted_35))
                    }), 128))
                  : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(__props.chartData.datasets, (ds, index) => {
                      return (_openBlock(), _createElementBlock("button", {
                        key: ds.label,
                        type: "button",
                        class: _normalizeClass(["inline-flex items-center gap-1.5 rounded-full border px-3 py-1 text-sm transition-colors", 
                  hiddenDatasets.value.has(index)
                    ? 'border-gray-200 bg-gray-50 text-gray-400'
                    : 'border-gray-300 bg-white text-gray-800 font-medium shadow-sm hover:bg-gray-50'
                ]),
                        onClick: $event => (toggleDataset(index))
                      }, [
                        _createElementVNode("span", {
                          class: _normalizeClass([
                    'inline-block w-4 rounded',
                    __props.chartType === 'stackedBar' ? 'h-3' : hiddenDatasets.value.has(index) ? 'h-0.5' : 'h-1',
                    hiddenDatasets.value.has(index) ? 'bg-gray-300' : ''
                  ]),
                          style: _normalizeStyle(hiddenDatasets.value.has(index) ? {} : { backgroundColor: ds.borderColor })
                        }, null, 6),
                        _createTextVNode(" " + _toDisplayString(ds.label), 1)
                      ], 10, _hoisted_36))
                    }), 128))
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    (__props.hasSupportingTable && !__props.loading)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _cache[19] || (_cache[19] = _createElementVNode("hr", { class: "border-gray-200 mx-4" }, null, -1)),
          _createElementVNode("div", _hoisted_37, [
            _createElementVNode("div", _hoisted_38, [
              _cache[15] || (_cache[15] = _createElementVNode("h4", { class: "text-base font-bold text-gray-900" }, "Summary Data", -1)),
              (__props.activeInChartProductIds != null && tableRowsForTable.value.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "inline-flex items-center justify-center rounded p-1 text-gray-500 hover:bg-gray-100 hover:text-gray-700 focus:outline-none focus:ring-1 focus:ring-brand-500",
                      title: allTableRowsVisible.value ? 'Hide all in chart' : 'Show all in chart',
                      onClick: _cache[10] || (_cache[10] = $event => (
                allTableRowsVisible.value
                  ? emit('active-chart-products-change', [])
                  : emit(
                      'active-chart-products-change',
                      tableRowsForTable.value.map(r => rowId(r)).filter(id => id != null)
                    )
              ))
                    }, [
                      (anyTableRowVisible.value)
                        ? (_openBlock(), _createBlock(_unref(EyeIcon), {
                            key: 0,
                            class: "h-4 w-4"
                          }))
                        : (_openBlock(), _createBlock(_unref(EyeSlashIcon), {
                            key: 1,
                            class: "h-4 w-4"
                          }))
                    ], 8, _hoisted_40)
                  ]))
                : (canToggleDatasets.value && tableRowsForTable.value.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "inline-flex items-center justify-center rounded p-1 text-gray-500 hover:bg-gray-100 hover:text-gray-700 focus:outline-none focus:ring-1 focus:ring-brand-500",
                        title: allDatasetsVisible.value ? 'Hide all in chart' : 'Show all in chart',
                        onClick: _cache[11] || (_cache[11] = $event => (toggleAllDatasets()))
                      }, [
                        (anyDatasetVisible.value)
                          ? (_openBlock(), _createBlock(_unref(EyeIcon), {
                              key: 0,
                              class: "h-4 w-4"
                            }))
                          : (_openBlock(), _createBlock(_unref(EyeSlashIcon), {
                              key: 1,
                              class: "h-4 w-4"
                            }))
                      ], 8, _hoisted_42)
                    ]))
                  : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_43, [
              _createElementVNode("table", _hoisted_44, [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", _hoisted_45, [
                    _createElementVNode("th", _hoisted_46, _toDisplayString(__props.labelColumnTitle), 1),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(displayTableData.value?.columns ?? __props.tableData?.columns ?? [], (col, colIdx) => {
                      return (_openBlock(), _createElementBlock("th", {
                        key: col.key,
                        class: _normalizeClass(["pb-2 pr-4 font-medium whitespace-nowrap transition-colors duration-150", __props.tableHoverEnabled && hoveredColIndex.value === colIdx ? 'text-gray-800' : ''])
                      }, _toDisplayString(col.label), 3))
                    }), 128)),
                    _cache[17] || (_cache[17] = _createElementVNode("th", { class: "pb-2 font-semibold text-gray-700 whitespace-nowrap" }, "TOTAL", -1)),
                    (__props.activeInChartProductIds != null || canToggleDatasets.value)
                      ? (_openBlock(), _createElementBlock("th", _hoisted_47, [...(_cache[16] || (_cache[16] = [
                          _createElementVNode("span", { class: "sr-only" }, "Show in chart", -1)
                        ]))]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("tbody", null, [
                  (tableRowsForTable.value.length === 0)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_48, [
                        _createElementVNode("td", {
                          colspan: tableColumnCount.value,
                          class: "py-8 text-center text-sm text-gray-400"
                        }, "No data to display", 8, _hoisted_49)
                      ]))
                    : _createCommentVNode("", true),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paginatedTableRows.value, (row, rowIndex) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: rowId(row) ?? rowIndex,
                      class: _normalizeClass(["border-t border-gray-100 transition-all duration-150", {
                  'cursor-pointer': __props.activeInChartProductIds != null || hasMultipleDatasets.value,
                  'cursor-default': __props.activeInChartProductIds == null && !hasMultipleDatasets.value,
                  'bg-gray-50': __props.tableHoverEnabled && hoveredRowLabel.value === row.label && !isRowHidden(row),
                  'opacity-40':
                    isRowHidden(row) || (__props.tableHoverEnabled && hoveredRowLabel.value != null && hoveredRowLabel.value !== row.label)
                }]),
                      onMouseenter: $event => (__props.tableHoverEnabled && startTableHover(row.label)),
                      onMouseleave: _cache[13] || (_cache[13] = $event => (__props.tableHoverEnabled && clearTableHover())),
                      onClick: $event => (onTableRowClick(row))
                    }, [
                      _createElementVNode("td", _hoisted_51, [
                        _createElementVNode("span", {
                          class: _normalizeClass(["inline-block w-2 h-2 rounded-full mr-2 align-middle transition-transform duration-150", __props.tableHoverEnabled && hoveredRowLabel.value === row.label ? 'scale-125' : '']),
                          style: _normalizeStyle({ backgroundColor: row.color || '#6b7280' })
                        }, null, 6),
                        _createTextVNode(" " + _toDisplayString(row.label), 1)
                      ]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(displayTableData.value?.columns ?? __props.tableData?.columns ?? [], (col, colIdx) => {
                        return (_openBlock(), _createElementBlock("td", {
                          key: col.key,
                          class: _normalizeClass(["py-2 pr-4 whitespace-nowrap transition-colors duration-150", [
                    (row.values?.[col.key] ?? '—') === '—' ? 'text-gray-300' : 'text-gray-700',
                    __props.tableHoverEnabled && hoveredRowLabel.value === row.label && hoveredColIndex.value === colIdx
                      ? 'bg-blue-50/60 font-semibold'
                      : '',
                    isRowHidden(row) ? 'line-through' : ''
                  ]]),
                          onMouseenter: $event => (__props.tableHoverEnabled && (hoveredColIndex.value = colIdx)),
                          onMouseleave: _cache[12] || (_cache[12] = $event => (__props.tableHoverEnabled && (hoveredColIndex.value = null)))
                        }, _toDisplayString(row.values?.[col.key] ?? '—'), 43, _hoisted_52))
                      }), 128)),
                      _createElementVNode("td", {
                        class: _normalizeClass(["py-2 font-semibold whitespace-nowrap", [
                    (row.total ?? '—') === '—' ? 'text-gray-300' : 'text-gray-900',
                    isRowHidden(row) ? 'line-through' : ''
                  ]])
                      }, _toDisplayString(row.total ?? '—'), 3),
                      (__props.activeInChartProductIds != null && rowId(row) != null)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_53, [
                            _createElementVNode("button", {
                              type: "button",
                              class: "inline-flex items-center justify-center rounded p-1 text-gray-500 hover:bg-gray-100 hover:text-gray-700 focus:outline-none focus:ring-1 focus:ring-brand-500",
                              title: activeInChartSet.value?.has(rowId(row)) ? 'Hide in chart' : 'Show in chart',
                              onClick: _withModifiers($event => (toggleActiveChartProduct(rowId(row))), ["stop"])
                            }, [
                              (!activeInChartSet.value?.has(rowId(row)))
                                ? (_openBlock(), _createBlock(_unref(EyeSlashIcon), {
                                    key: 0,
                                    class: "h-4 w-4"
                                  }))
                                : (_openBlock(), _createBlock(_unref(EyeIcon), {
                                    key: 1,
                                    class: "h-4 w-4"
                                  }))
                            ], 8, _hoisted_54)
                          ]))
                        : (canToggleDatasets.value && datasetIndexForRow(row) >= 0)
                          ? (_openBlock(), _createElementBlock("td", _hoisted_55, [
                              _createElementVNode("button", {
                                type: "button",
                                class: "inline-flex items-center justify-center rounded p-1 text-gray-500 hover:bg-gray-100 hover:text-gray-700 focus:outline-none focus:ring-1 focus:ring-brand-500",
                                title: hiddenDatasets.value.has(datasetIndexForRow(row)) ? 'Show in chart' : 'Hide in chart',
                                onClick: _withModifiers($event => (toggleDataset(datasetIndexForRow(row))), ["stop"])
                              }, [
                                (hiddenDatasets.value.has(datasetIndexForRow(row)))
                                  ? (_openBlock(), _createBlock(_unref(EyeSlashIcon), {
                                      key: 0,
                                      class: "h-4 w-4"
                                    }))
                                  : (_openBlock(), _createBlock(_unref(EyeIcon), {
                                      key: 1,
                                      class: "h-4 w-4"
                                    }))
                              ], 8, _hoisted_56)
                            ]))
                          : _createCommentVNode("", true)
                    ], 42, _hoisted_50))
                  }), 128))
                ]),
                (tableTotalRow.value && !(displayTableData.value?.hideTotalRow ?? __props.tableData?.hideTotalRow))
                  ? (_openBlock(), _createElementBlock("tfoot", _hoisted_57, [
                      _createElementVNode("tr", _hoisted_58, [
                        _cache[18] || (_cache[18] = _createElementVNode("td", { class: "py-2 pr-4 whitespace-nowrap" }, "Total", -1)),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(displayTableData.value?.columns ?? __props.tableData?.columns ?? [], (col) => {
                          return (_openBlock(), _createElementBlock("td", {
                            key: 'total-' + col.key,
                            class: "py-2 pr-4 whitespace-nowrap"
                          }, _toDisplayString(tableTotalRow.value.values[col.key] ?? '—'), 1))
                        }), 128)),
                        _createElementVNode("td", _hoisted_59, _toDisplayString(tableTotalRow.value.total ?? '—'), 1),
                        (__props.activeInChartProductIds != null || canToggleDatasets.value)
                          ? (_openBlock(), _createElementBlock("td", _hoisted_60))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            (tableRowsForTable.value.length > _unref(tablePageSize))
              ? (_openBlock(), _createBlock(TablePagination, {
                  key: 0,
                  items: tableRowsForTable.value,
                  page: tablePage.value,
                  "page-size": _unref(tablePageSize),
                  "has-transparent-bg": false,
                  onOnPageChange: onTablePageChange
                }, null, 8, ["items", "page", "page-size"]))
              : _createCommentVNode("", true)
          ])
        ], 64))
      : _createCommentVNode("", true)
  ]))
}
}

}